export default __webpack_public_path__ + "static/media/contactMail.0bc4d365.png";